import entity from '../../../models/mlm/reports'

export default [
  {
    path: '/reports',
    meta: {
      entity,
      requiresPermissionTo: 'reports',
      crud: 'list'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/reports/new',
    meta: {
      entity,
      requiresPermissionTo: 'reports',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  },
  {
    path: '/reports/:id',
    meta: {
      entity,
      requiresPermissionTo: 'reports',
      crud: 'form'
    },
    component: () =>
      import(
        /* webpackChunkName: 'banners' */ '@/views/dynamic/DynamicIndex.vue'
      )
  }
]
